/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from "react";
import TableTemplate from "./Table";
import CardLayout from "../Cards/CardLayout";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import CardError from "../feedBacks/CardError";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import { REFETCH_CONFIGURATION, ROWS_PER_PAGE } from "../../utils/constants";
import NoDeviceCardError from "../feedBacks/NoDeviceCardError";
import { useUtils } from "../../customHooks/useUtils";



//  "device_id": "AN54101366",
//             "device_name": "C147",
//             "load_ratio": 0.0,
//             "current_unbalance": 0.0,
//             "voltage_unbalance": 0.0

const ThresholdTable = ({ company_id }: { company_id?: string }) => {
  const { FEEDBACK_MESSAGES, t } = useUtils();
  const columns = [
    t("table.device_name"),
    t("chart.transformer_load_rate"),
    t("readings.voltage_unbalance_factor"),
    t("readings.current_unbalance_factor"),
  ];
  const [page, setPage] = React.useState(1);
  const [isNextPageLoading, setIsNextPageLoading] = React.useState(false);
  // const ROWS_PER_PAGE = 10;
  const handlePageChange = (newPage: number) => {
    setIsNextPageLoading(true);
    setPage(newPage);
  };
  const {
    data,
    isLoading: isDataLoading,
    error,
    refetch,
  }: any = useFetchData(
    ["/operations", "fethcThresholdExceedForSites", company_id],
    "/operations/percentage-exceeded-table",
    {
      page,
      page_size: ROWS_PER_PAGE,
      company_id,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  const isLoading = isDataLoading || isNextPageLoading;
  const tableData =
    (data as any)?.results.map((item: any) => ({
      [t("table.device_name")]: item.device_name,
      [t("readings.current_unbalance_factor")]: item.current_unbalance,
      [t("readings.voltage_unbalance_factor")]: item.voltage_unbalance,
      [t("chart.transformer_load_rate")]: item.load_ratio,
      ...item,
    })) ?? [];

  useEffect(() => {
    refetch().finally(() => {
      setIsNextPageLoading(false);
    });
  }, [page, refetch]);
  return (
    <CardLayout
      title={t("table.percent_exceed_threshold")}
      className="lg:!max-w-[50%] flex-1 lg:!justify-items-start lg:!items-start"
    >
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        (error as any).response.data.detail ? (
          <NoDeviceCardError
            message={FEEDBACK_MESSAGES.NO_DEVICE}
            className="!max-h-[150px]"
          />
        ) : (
          <CardError message="Error fetching data" />
        )
      ) : !tableData || tableData.length === 0 ? (
        <NoContent message="No devices found" />
      ) : (
        <TableTemplate
          data={tableData}
          columns={columns}
          totalCount={data?.total_results || 0}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={ROWS_PER_PAGE}
        />
      )}
    </CardLayout>
  );
};

export default ThresholdTable;
